import { render, staticRenderFns } from "./ESGModulePage.vue?vue&type=template&id=7ba53048&scoped=true"
import script from "./ESGModulePage.vue?vue&type=script&lang=js"
export * from "./ESGModulePage.vue?vue&type=script&lang=js"
import style0 from "./ESGModulePage.vue?vue&type=style&index=0&id=7ba53048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba53048",
  null
  
)

export default component.exports